import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ReportInput } from '../../power-bi/model/power-bi.model';
import { APP_CONFIG, constants } from '../../common/constants';
import { AppConfig } from '../../model/app-config.model';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('titleDiv') titleDiv: ElementRef<HTMLElement>;
  powerBIConfig: ReportInput;
  reportUrl: string;

  constructor(@Inject(APP_CONFIG) appConfig: AppConfig) {
    // this.powerBIConfig = appConfig.scoreCardPowerBIReport;
    // this.reportUrl = constants.PowerBIDomainUrl
    //               + 'groups/' + this.powerBIConfig.groupId
    //               + '/reports/' + this.powerBIConfig.reportId
    //               + '/' + this.powerBIConfig.pageName;
  }

  ngAfterViewInit() {
    this.titleDiv.nativeElement.focus();
  }

}

